export const SubscriptionPlan = Object.freeze({
    Inactive: 0,
    LegacyStarter: 1,
    LegacyBuilder: 2,
    LegacyGrower: 3,
    LegacyScaler: 4,
    Starter: 5,
    Lite: 6,
    Professional: 7,
    Elite: 8,
    Unlimited: 100
  });

export const GetPlanName = (plan) => {
    switch (plan) {
        case SubscriptionPlan.LegacyBuilder:
            return "LegacyBuilder";
        case SubscriptionPlan.LegacyGrower:
            return "LegacyGrower";
        case SubscriptionPlan.LegacyScaler:
            return "LegacyScaler";
        case SubscriptionPlan.Unlimited:
            return "Unlimited";
        case SubscriptionPlan.Lite:
            return "Lite";
        case SubscriptionPlan.Professional:
            return "Professional";
        case SubscriptionPlan.Elite:
            return "Elite";
        case SubscriptionPlan.LegacyStarter:
            return "LegacyStarter";
        case SubscriptionPlan.Starter:
        default:
            return "Starter";
    }
}

// The name merchants see. Elite is shown as "Business"; GetPlanName stays the internal name, because trial keys,
// discount codes' AppliesToPlans and the Shopify charge name ("Disco Elite Subscription") all use it.
export const GetPlanDisplayName = (plan) => (plan === SubscriptionPlan.Elite ? "Business" : GetPlanName(plan));

export const DiscountCodeStatus = Object.freeze({
    Active: 0,
    Used: 1,
    Expired: 2,
    Invalid: 3
});

export const DiscountKind = Object.freeze({
    Percent: 0,
    Amount: 1
});